export default {
  namespaced: true,

  getters: {
    enabled(state, getters, rootState, rootGetters) {
      const config = rootGetters['builder/config'];

      if (!config) {
        return false;
      }

      return Boolean(config.relationships);
    },
  },
};
